<div class="summaryContainer">
  <div class="summaryPhotos">
    <app-gallery class="summaryGallery"></app-gallery>
    <div class="summaryForm">
      <p class="text-small message">Do you have additional notes?</p>
      <textarea #summaryNotes name="summaryNotes" (change)="saveNotes($event)"></textarea>
      <div class="navbar-button closeSummary" (click)="closeSummary()"> Back</div>
      <div class="buttonContainer">
        <!-- <button class=".text-small formBtn send" (click)="sendEmail()">Send via Emial</button> -->
        <button *ngIf="showButton === 'print'" class=".text-small formBtn"
          (click)="print()">{{printButtonText}}</button>
        <div *ngIf="showButton === 'loader'" class="loaderContainer">
          <span class="circle"></span>
          <span class="circle"></span>
          <span class="circle"></span>
          <span class="circle"></span>
        </div>
        <button *ngIf="showButton === 'download'" class=".text-small formBtn">
          <a [href]="urlToPdf" class="linkToPdf">Download PDF</a>
        </button>
      </div>
    </div>
  </div>
  <div class="summaryInfo">
    <!-- <p class="text group-name">You have <span> fabulous </span> taste</p> -->
    <hr class="line">
    <div class="listBox">
      <div *ngIf="showLoader" class="loaderContainer summaryLoader">
        <span class="circle"></span>
        <span class="circle"></span>
        <span class="circle"></span>
        <span class="circle"></span>
      </div>
      <table *ngIf="!showLoader" class="summaryTable">
        <tr class="summaryRow" *ngFor="let pair of printedAttributesWithChoices | keyvalue">
          <td class="description">{{pair.key}}</td>
          <td class="description description-opacity">{{pair.value}}</td>
        </tr>
      </table>
    </div>
    <ng-container *ngIf="showPrice | async">
      <p *ngIf="!showLoader" class="text group-name finishPrice">Price: ${{price}}</p>
    </ng-container>
  </div>
</div>
<div *ngIf="showEmailModal" class="sendingEmail">
  <app-send-email (closeModal)="closeModal($event)"></app-send-email>
</div>
<div *ngIf="showQuestionModal" class="sendingEmail">
  <app-type-note-modal (closeModalQuestions)="closeModal($event)"></app-type-note-modal>
</div>